import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import DatePicker from 'react-datepicker';
import TableWithPagination from './../common/TableWithPagination';
import GreetingCard from '../../hooks/pedidos/GreetingCard';
import StatsCards from '../../hooks/pedidos/StatsCards';
import InfoCards from './../common/InfoCards';
import { useApi } from './../../hooks/useApi';
import { Icon } from '@iconify/react';

const SalesOrdersPage = () => {
    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour >= 5 && hour < 12) return 'Buenos días';
        if (hour >= 12 && hour < 19) return 'Buenas tardes';
        return 'Buenas noches';
    };

    const token = localStorage.getItem('token');
    const { get, post, error } = useApi();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [greeting, setGreeting] = useState(getGreeting());
    const { user } = useContext(AuthContext);
    const [filtroEstatus, setFiltroEstatus] = useState('');
    const today = new Date();
    const [dateRange, setDateRange] = useState([today, today]);
    const [startDate, endDate] = dateRange;


  // Filtros
  const [filters, setFilters] = useState({
    chainId: '',
    businessId: '',
    fechaInicio: today.toISOString().split('T')[0],
    fechaFin: today.toISOString().split('T')[0],
  });

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await get('getSalesOrdes', {
        params: filters
      });
      console.log(response);
      setOrders(response);
    } catch (error) {
      console.error('Error al obtener órdenes:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleSearch = () => {
    fetchData();
  };

   const handleView = async (id) => {
    try {
        console.log(id);
    } catch (error) {
      console.error('Error al obtener detalle:', error);
    }
  };

  const columns = [
    { header: 'Fecha', accessor: 'id' },
    { header: 'Cadena', accessor: 'salesOrderId' },
    { header: 'Archivo', accessor: '' },
    { header: 'Estatus', accessor: 'businessId'},
    ];

    const cardsData = [
        {
            icon: 'heroicons-outline:chart-pie',
            bgColor: 'bg-info-500',
            textColor: 'text-info-500',
            label: 'Total Archivos',
            value: 0,
            estatus: 'total',
        },
        {
            icon: 'heroicons-outline:calculator',
            bgColor: 'bg-success-500',
            textColor: 'text-success-500',
            label: 'Procesados',
            value: 0,
            estatus: 'procesados',
        },
        {
            icon: 'heroicons-outline:x-circle',
            bgColor: 'bg-danger-500',
            textColor: 'text-danger-500',
            label: 'Con Error',
            value: 0,
            estatus: 'error',
        },
    ];

  return (
    <div className="p-4">
          <div className="grid grid-cols-12 gap-5 mb-5 justify-start">
              <div className="2xl:col-span-9 lg:col-span-9 col-span-12 justify-self-start">
                  <InfoCards cardsData={cardsData} />
              </div>
          </div>

        <div className="grid grid-cols-12 gap-5">
            <div className="xl:col-span-12 col-span-12">
              <div className="bg-white shadow-md rounded-lg overflow-hidden">
                <div className="p-6">
                    <div className="overflow-x-auto"></div>
                     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6 items-end bg-white p-4 ">
                        {/* Fecha */}
                        <div className="md:col-span-1">
                          <label className="block text-sm font-medium text-slate-700 mb-1">Rango de fechas:</label>
                          <div className="relative">
                            <Icon icon="mdi:calendar" className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5 z-20" />
                            <DatePicker
                              selectsRange
                              startDate={startDate}
                              endDate={endDate}
                              onChange={(update) => {
                                setDateRange(update);
                                setFilters((prev) => ({
                                  ...prev,
                                  fechaInicio: update[0] ? update[0].toISOString().split('T')[0] : '',
                                  fechaFin: update[1] ? update[1].toISOString().split('T')[0] : ''
                                }));
                                if (update[0] && update[1]) {
                                  fetchData();
                                }
                              }}
                              className="w-full pl-10 pr-3 py-2 text-sm bg-white text-slate-700 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#233F93] focus:outline-none shadow-sm"
                              calendarClassName="!z-50"
                              portal={true}
                              dateFormat="dd/MM/yyyy"
                            />
                          </div>
                        </div>

                        {/* Cadena */}
                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1">Cadena:</label>
                          <select
                            name="chainId"
                            value={filters.chainId}
                            onChange={handleInputChange}
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-[#233F93] focus:outline-none shadow-sm"
                          >
                            <option value="">Todas las cadenas</option>
                            <option value="7EL">7Eleven</option>
                            <option value="ALS">AlSuper</option>
                            <option value="DUE">ElDuero</option>
                            <option value="WAL">Walmart</option>
                            <option value="CAL">Calimax</option>
                            <option value="HEB">HEB</option>
                            <option value="MER">Merco</option>
                            <option value="COS">Costco</option>
                            <option value="CHE">Chedrahui</option>
                            <option value="CIT">CIT</option>
                          </select>
                        </div>

                        {/* Business ID */}
                              {/*<div>
                          <label className="block text-sm font-medium text-slate-700 mb-1">Business ID:</label>
                          <div className="relative">
                            <Icon icon="mdi:identifier" className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5" />
                            <input
                              type="text"
                              name="businessId"
                              value={filters.businessId}
                              onChange={handleInputChange}
                              placeholder="Business ID"
                              className="w-full pl-10 pr-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-[#233F93] focus:outline-none shadow-sm"
                            />
                          </div>
                        </div>*/}

                        {/* Botón Buscar */}
                        <div className="md:col-span-1 flex justify-start md:justify-start lg:justify-start xl:justify-start">
                          <button
                            onClick={handleSearch}
                            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-[#233F93] hover:bg-[#1b3277] rounded-md shadow focus:outline-none transition-all"
                          >
                            <Icon icon="mdi:magnify" className="text-base" />
                            Buscar
                          </button>
                        </div>
                      </div>
                      <div className="overflow-x-auto"> 
                        <TableWithPagination
                            columns={columns}
                            data={Array.isArray(orders) ? orders:[]}
                            onView={handleView}
                            onRefresh={fetchData}
                            showView={false}
                            showEdit={false}
                            showDelete={false}
                            />
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default SalesOrdersPage;
